import { debounce } from '../utils';

/**
 * Support for header & menu
 */
export default class KingsfordHeader {
    // ctor assign vars & init
    constructor() {
        this.header = document.querySelector('.js-kingsford-header');
        this.menuButton = document.querySelector('.js-header-menu-button');
        this.megaDropdown = document.querySelector('.js-mega-dropdown');
        this.overlay = document.querySelector('.js-header-overlay');
        this.asideMenu = document.querySelector('.js-header-drawer');
        this.menuItems = document.querySelectorAll('.js-header-navigation-list li.has-submenu');
        this.allSubmenus = document.querySelectorAll('[data-submenu]');
        this.allSubmenusThatHasGridItems = document.querySelectorAll('.js-mega-dropdown li.has-gridmenu');
        this.allSubmenuLinkItems = document.querySelectorAll('.js-header-submenu-link');
        this.allSubmenuGridItems = document.querySelectorAll('.js-header-submenu-grid');
        this.desktopHeaderParent = document.querySelector('.js-header-parent');
        this.mobileMenuItems = document.querySelectorAll('.js-header-mobile-navigation-list li.has-submenu');
        this.searchButton = document.querySelector('.kingsford-header__global-wrapper__search-area__search-form button');
        this.timer = null;

        this.previousScrollY = window.scrollY;

        if (window.scrollY === 0) {
            this.header.classList.add('initial-phase');
        }

        this.init();
    }

    /**
     * assign event handlers
     */
    init() {
        window.addEventListener('resize', debounce(this.onResize.bind(this), 200), { passive: true });
        document.addEventListener('scroll', this.onPageScroll.bind(this), { passive: true });

        this.menuButton.addEventListener('click', this.onMenuButtonClick.bind(this));
        this.overlay.addEventListener('click', this.onOverlayClick.bind(this));
        this.desktopHeaderParent.addEventListener('mouseleave', this.handleMenuMouseLeave.bind(this));

        this.menuItems.forEach((item) => {
            item.addEventListener('mouseover', this.handleMenuMouseOver.bind(this, item));
            // item.addEventListener('mouseout', this.handleMenuMouseOut.bind(this, item));
            item.addEventListener('keydown', this.handleMenuKeyDown.bind(this, item));
            item.addEventListener('focusout', this.handleMenuFocusOut.bind(this, item));
        });

        this.allSubmenus.forEach((item) => {
            let alreadyActivatedASubmenuLink = false;
            item.querySelectorAll('.js-header-submenu-link').forEach((linkItem) => {
                if (!alreadyActivatedASubmenuLink && linkItem.parentElement.classList.contains('has-gridmenu')) {
                    linkItem.classList.add('is-active');
                    alreadyActivatedASubmenuLink = true;
                }
            });

            const firstGridItem = item.querySelector('.js-header-submenu-grid');
            if (firstGridItem) {
                firstGridItem.classList.add('is-active');
                firstGridItem.parentElement.style.height = `${firstGridItem.offsetHeight}px`;
            }
        });

        this.allSubmenusThatHasGridItems.forEach((item) => {
            const linkItem = item.querySelector('a');
            const gridItem = document.querySelector(
                `.js-mega-dropdown [data-grid-index="${linkItem.dataset.menuIndex}"]`
            );
            linkItem.addEventListener('mouseover', this.handleSubmenuGridMouseOver.bind(this, linkItem, gridItem));
            linkItem.addEventListener('focus', this.handleSubmenuGridFocus.bind(this, linkItem, gridItem));
        });

        this.mobileMenuItems.forEach((item) => {
            const accordionToggler = item.querySelector('.accordion-toggler');
            accordionToggler.addEventListener('click', this.onMenuTogglerClick.bind(this, accordionToggler));
        });
    }

    // resize handler
    onResize() {
        if (window.innerWidth > 1024) {
            this.closeDrawer();
        }
    }

    // scroll handler
    onPageScroll() {
        const currentScrollY = window.scrollY;
        const isScrollingDown = currentScrollY > this.previousScrollY;
        const headerHeight = this.header.offsetHeight;

        if (currentScrollY === 0) {
            this.header.classList.add('initial-phase');
        } else {
            this.header.classList.remove('initial-phase');
        }

        if (!this.asideMenu.classList.contains('is-active')) {
            if (isScrollingDown && currentScrollY > headerHeight / 4) {
                this.header.classList.add('scrolling-up');
            } else {
                this.header.classList.remove('scrolling-up');
            }
        }

        this.previousScrollY = currentScrollY;
    }

    // menu click handler
    onMenuButtonClick() {
        if (this.asideMenu.classList.contains('is-active')) {
            this.closeDrawer();
            const body = document.querySelector('body');
            body.classList.remove('stop-scrolling');
            $('body').unbind('touchmove');
        } else {
            this.openDrawer();
            const body = document.querySelector('body');
            body.classList.add('stop-scrolling');
            $('body').bind('touchmove', (e) =>{e.preventDefault()});
        }
    }

    // overlay click to close drawer
    onOverlayClick() {
        this.closeDrawer();
    }

    // open menu drawer
    openDrawer() {
        this.menuButton.classList.add('is-active');
        this.overlay.classList.add('is-active');
        this.asideMenu.classList.add('is-active');
    }

    // close menu drawer
    closeDrawer() {
        this.menuButton.classList.remove('is-active');
        this.overlay.classList.remove('is-active');
        this.asideMenu.classList.remove('is-active');
    }

    // mouse move handler
    handleMenuMouseOver(menuItem) {
        this.openMegaDropdown();
        this.openSubMenu(menuItem);
        this.closeAllSubmenus(menuItem);
    }

    // mouse leave handler
    handleMenuMouseLeave() {
        this.closeMegaDropdown();
        this.closeAllSubmenus();
    }

    // keydown handler
    handleMenuKeyDown(menuItem, event) {
        console.info('menuItem: ', menuItem);

        if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.openMegaDropdown();
            this.openSubMenu(menuItem);
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault();
            this.closeMegaDropdown();
            this.closeSubMenu(menuItem);
            menuItem.children[0].focus();
        }
    }

    // focus loss handler
    handleMenuFocusOut(menuItem, event) {
        const leavingParent = !menuItem.contains(event.relatedTarget);

        if (leavingParent) {
            this.closeSubMenu(menuItem);
        }
    }

    // open submenu
    openSubMenu(menuItem) {
        menuItem.querySelector('a').setAttribute('aria-expanded', 'true');
        menuItem.classList.add('is-open');

        const menu = menuItem.querySelector('a').getAttribute('data-menu');

        // Close all submenus
        this.allSubmenus.forEach((item) => {
            item.classList.remove('is-open');
        });

        // Open selected submenu
        const submenu = document.querySelector(`[data-submenu="${menu}"]`);
        submenu.classList.add('is-open');
        const gridItem = submenu.querySelector('.js-header-submenu-grid.is-active');
        gridItem.parentElement.style.height = `${gridItem.offsetHeight}px`;
        submenu.parentElement.style.height = `${submenu.offsetHeight}px`;

        submenu.querySelector('ul li').children[0].focus();
    }

    openMegaDropdown() {
        this.overlay.classList.add('is-active');
        this.megaDropdown.classList.remove('is-closed');
        this.megaDropdown.classList.add('is-open');
    }

    closeMegaDropdown() {
        this.overlay.classList.remove('is-active');
        this.megaDropdown.classList.remove('is-open');
        this.megaDropdown.classList.add('is-closed');
    }

    // close submenu
    closeSubMenu(menuItem) {
        menuItem.querySelector('a').setAttribute('aria-expanded', 'false');
        menuItem.classList.remove('is-open');
    }

    // close all submenus
    closeAllSubmenus(menuItem) {
        this.menuItems.forEach((item) => {
            if (item !== menuItem) {
                this.closeSubMenu(item);
            }
        });
    }

    // activate link
    activateLinkItem(linkItem) {
        linkItem.classList.add('is-active');
    }

    // deactivate link
    deactivateLinkItem(linkItem) {
        linkItem.classList.remove('is-active');
    }

    // deactivate all links
    deactivateAllLinkItems() {
        this.allSubmenuLinkItems.forEach((item) => {
            this.deactivateLinkItem(item);
        });
    }

    // deactivate all links in same submenu
    deactivateAllLinkItemsFromSameSubmenu(linkItem) {
        const [parentIndex] = linkItem.dataset.menuIndex.split('-');
        const linkItems = document.querySelectorAll(`.js-mega-dropdown [data-menu-index^="${parentIndex}-"]`);
        linkItems.forEach((item) => {
            this.deactivateLinkItem(item);
        });
    }

    // show grid item
    showGridItem(gridItem) {
        gridItem.classList.add('is-active');
        gridItem.parentElement.style.height = `${gridItem.offsetHeight}px`;

        const submenu = gridItem.closest(`[data-submenu]`);
        submenu.parentElement.style.height = `${submenu.offsetHeight}px`;
    }

    // hide grid item
    hideGridItem(gridItem) {
        gridItem.classList.remove('is-active');
    }

    // hide all grid items from submenu
    hideAllGridItemsFromSameSubmenu(gridItem) {
        const [parentIndex] = gridItem.dataset.gridIndex.split('-');
        const gridItems = document.querySelectorAll(`.js-mega-dropdown [data-grid-index^="${parentIndex}-"]`);
        gridItems.forEach((item) => {
            this.hideGridItem(item);
        });
    }

    // hide all grid items
    hideAllGridItems() {
        this.allSubmenuGridItems.forEach((item) => {
            this.hideGridItem(item);
        });
    }

    // submenu grid mouse over handler
    handleSubmenuGridMouseOver(linkItem, gridItem) {
        this.deactivateAllLinkItemsFromSameSubmenu(linkItem);
        this.activateLinkItem(linkItem);
        this.hideAllGridItemsFromSameSubmenu(gridItem);
        this.showGridItem(gridItem);
    }

    // submenu grid focus handler
    handleSubmenuGridFocus(linkItem, gridItem) {
        this.deactivateAllLinkItemsFromSameSubmenu(linkItem);
        this.activateLinkItem(linkItem);
        this.hideAllGridItemsFromSameSubmenu(gridItem);
        this.showGridItem(gridItem);
    }

    // click handler for toggline menus on mobile
    onMenuTogglerClick(toggler) {
        const content = toggler.nextElementSibling;

        if (content.style.maxHeight) {
            toggler.previousElementSibling.classList.remove('is-active');
            toggler.classList.remove('is-active');
            toggler.setAttribute('aria-expanded', 'false');
            content.classList.add('collapsed');
            content.style.maxHeight = null;
        } else {
            toggler.previousElementSibling.classList.add('is-active');
            toggler.classList.add('is-active');
            toggler.setAttribute('aria-expanded', 'true');
            content.classList.remove('collapsed');
            content.style.maxHeight = `${content.scrollHeight}px`;
        }
    }
}
